import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        ngModel: '=',
        ngDisabled: '=',
        defaultTime: '='
    },
    template: `
        <datepicker-api ng-model="vm.date" ng-disabled="vm.ngDisabled"></datepicker-api>
        <timepicker ng-model="vm.time" ng-disabled="vm.ngDisabled"></timepicker>
    `
})
export default class {
    constructor ($scope, moment) {
        this.moment = moment;
        $scope.$watch('vm.date', () => {
            this.updateNgModel();
        });

        $scope.$watch('vm.time', () => {
            this.updateNgModel();
        });
    }

    $onInit () {
        if (this.ngModel) {
            const date = this.moment.utc(this.ngModel).local().toDate();
            this.date = date;
            this.time = date;
        }
    }

    updateNgModel () {
        if (this.date) {
            const time = this.time ? this.moment(this.time).format('HH:mm:00') : '23:59:00';
            const temp = `${this.moment(this.date).format('YYYY-MM-DD')} ${time}`;

            this.ngModel = this.moment(temp).utc().format('YYYY-MM-DD HH:mm:00');
        }
        else {
            this.ngModel = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/datetimepicker/index.js